module.exports = __webpack_public_path__ + "static/img/HK-Android1.e717ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HK-Android1.png
// module id = ag8Z
// module chunks = 4